import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import GroupIcon from '@material-ui/icons/Group';
import PropTypes from 'prop-types';
import React from 'react';
import AreYouSure from '../../core/AreYouSure';
import BasicChip from '../../core/BasicChip';
import { globalStyles as styles } from '../../core/style/gstheme';
import TitledPanel from '../../core/TitledPanel';
import { ENTITLEMENTS } from '../utils/constants';
import { checkResourceEntitlements } from '../utils/utils';
import ViewOnly from '../ViewOnly';
import withGS from '../withGShoc';

class GroupDetail extends React.Component {

    state = {
        areYouSure: false
    };

    checkIfSure = () => this.setState({ areYouSure: true });

    onSure = () => {
        this.setState({ areYouSure: false });
        this.props.onDeleteGroup(this.props.data.id);
    };

    onNotSure = () => this.setState({ areYouSure: false });

    getEntLabel(id) {
        const isFound = this.props.entitlements.find(ent => ent.id === id);
        const label = isFound ? isFound.label.en : id;
        return label;
    }

    handleDeleteEnt = (id) => this.props.onDelete('entitlement', id);

    handleAddEnt = (id) => this.props.onAdd('entitlement', id);

    sortGroups = (groups) => {
        return groups.sort((a, b) => {
            let orderA = this.getEntLabel(a);
            let orderB = this.getEntLabel(b);
            if (orderA < orderB) return -1;
            if (orderA > orderB) return 1;
            return 0;
        });
    };

    sortAvailableGroups = (groups) => {
        return groups.sort((a, b) => {
            let orderA = this.getEntLabel(a.id);
            let orderB = this.getEntLabel(b.id);
            if (orderA < orderB) return -1;
            if (orderA > orderB) return 1;
            return 0;
        });
    };

    render() {

        const { classes, data } = this.props;
        const { areYouSure } = this.state;

        const isReadOnly = data.id === "https://graphifi.com/data/usergroup/admins"
            || checkResourceEntitlements(data, [ENTITLEMENTS.EDIT_GROUP]);
        const availableEnts = data.entitlement ?
            this.props.entitlements.filter(ent => !data.entitlement.includes(ent.id))
            :
            this.props.entitlements;

        return (
            <div>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <div style={{ display: 'flex' }}>
                        <Avatar className={classes.primaryAvatar}>
                            <GroupIcon />
                        </Avatar>
                        <Typography style={{ marginLeft: '10px', marginTop: '3px' }} className={classes.mainHeading}>{data.label.en}{isReadOnly && <ViewOnly />}</Typography>
                    </div>
                    {!isReadOnly &&
                        <Tooltip title='Delete group' style={{ alignSelf: 'flex-end', marginTop: '5px' }}>
                            <IconButton data-test="delete-group" size="small" onClick={this.checkIfSure} className={classes.deleteButton}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </div>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TitledPanel dataTest="available-entitlements" title="Available Entitlements" height="full">
                            {availableEnts.length > 0 && this.sortAvailableGroups(availableEnts).map((availableEnt, index) =>
                                <BasicChip
                                    title="E"
                                    dataTest={"entitlement-" + availableEnt.id}
                                    key={"available-chip-" + index}
                                    onClick={!isReadOnly ? (() => this.handleAddEnt(availableEnt.id)) : null}
                                    label={this.getEntLabel(availableEnt.id)}
                                />
                            )}
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TitledPanel dataTest="group-entitlements" title="Group Entitlements" height="full">
                            {data.entitlement && this.sortGroups(data.entitlement).map((allowedEnt, index) =>
                                <BasicChip
                                    title="E"
                                    dataTest={"entitlement-" + allowedEnt}
                                    key={"assigned-chip-" + index}
                                    onDelete={!isReadOnly ? (() => this.handleDeleteEnt(allowedEnt)) : null}
                                    label={this.getEntLabel(allowedEnt)}
                                />
                            )}
                        </TitledPanel>
                    </Grid>
                </Grid>
                {areYouSure && <AreYouSure onSure={this.onSure} onNotSure={this.onNotSure} message="Do you really want to delete this group?" />}
            </div>
        );
    }
}

GroupDetail.propTypes = {
    classes: PropTypes.object,
    onAdd: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onDeleteGroup: PropTypes.func.isRequired,
    entitlements: PropTypes.array,
    id: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(GroupDetail));